import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import { Link, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import RangeSlider from '../common/range-slider';
import {
  getTenant,
  updateTenant,
  UPDATE_TENANT_SUCCESS
} from '../redux/modules/auth';
import { addAlert } from '../redux/modules/app';
import Datepicker from './date-picker';
import CheckBox from './check-box';
import i18n from 'kodyl-js/i18n/react';
import Input from '../common/forms/input';
import { slugify, formatDate } from '../utils/format';
import {
  RENT_MIN,
  RENT_MAX,
  RENT_STEP,
  RENT_DEFAULT,
  ROOMS_MIN,
  ROOMS_MAX,
  ROOMS_STEP,
  ROOMS_DEFAULT,
  SIZE_MIN,
  SIZE_MAX,
  SIZE_STEP,
  SIZE_DEFAULT
} from '../common/defaults';
import LoadingSpinner from '../common/loading-spinner';

const FAIL = 'fail';
const SUCCESS = 'success';

@connect(
  ({
    auth: { user, tenant, loading: userLoading },
    subscriptions: { subscriber, list: subscriptions },
    cities: { list: cities }
  }) => ({ user, userLoading, tenant, cities, subscriber, subscriptions }),
  { updateTenant, addAlert }
)
@i18n
class Tenant extends Component {
  static fetchData({ dispatch }) {
    return dispatch(getTenant());
  }

  constructor(props) {
    super(props);
    const { tenant } = props;
    this.state = {
      loading: false,
      loaded: false,
      update: false,
      data: new Map([
        ['housing-rent', RENT_DEFAULT],
        ['housing-rooms', ROOMS_DEFAULT],
        ['housing-size', SIZE_DEFAULT]
      ]),
      inputValue: (tenant && tenant.housing && tenant.housing.area) || '',
      suggestions: []
    };
  }

  componentWillMount() {
    this.mapPropsToState(this.props.tenant, this.props.loading);
  }

  componentWillReceiveProps(nextProps) {
    const { tenant } = nextProps;

    this.mapPropsToState(tenant, nextProps.loading);
  }

  mapPropsToState(tenant, loading) {
    if (this.state.loaded && loading) {
      return;
    }

    const data = this.state.data;

    function walk(obj, prefix = '') {
      Object.keys(obj).forEach(k => {
        const value = obj[k];
        const key = `${prefix}${k}`;

        if (Array.isArray(value)) {
          value.forEach(val => {
            data.set(`${key}-${val}`, true);
          });
          return;
        }
        if (
          typeof value === 'object' &&
          typeof value.hasOwnProperty === 'function'
        ) {
          return walk(value, `${key}-`);
        }
        data.set(key, value);
      });
    }

    if (tenant && Object.keys(tenant).length) {
      walk(tenant);
    }

    this.setState({ loaded: true, data });
  }

  setValue = (key, value) => {
    const { data } = this.state;

    data.set(key, value);

    this.setState({ data });
  };

  getValue = (range, type) => {
    this.setValue(type, range);
  };

  handleSubmit = ev => {
    if (ev) {
      ev.preventDefault();
    }

    const { data } = this.state;
    const { addAlert, subscriber } = this.props;

    this.setState({ loading: true }, () => {
      this.props
        .updateTenant(data)
        .then(action => {
          if (action.type === UPDATE_TENANT_SUCCESS) {
            this.setState({ loading: false, update: SUCCESS });
          }
          return action;
        })
        .then(() => {
          if (!subscriber) {
            addAlert({
              style: 'warning',
              headline: this.i18n(
                'Oops! Your tenant ad has not been activated'
              ),
              views: 1
            });
            return browserHistory.push('/profile/subscription');
          }
        })
        .catch(() => {
          this.setState({ loading: false, update: FAIL });
        });
    });
  };

  handleChange = ev => {
    if (typeof ev === 'string') {
      this.setValue('housing-available', ev);
      return;
    }
    const target = ev.target;
    const type = target.getAttribute('type');
    const key = target.getAttribute('name');
    const value = type === 'checkbox' ? target.checked : target.value;
    this.setValue(key, value);
  };

  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({ suggestions: this.filterSearch(value) });
  };

  onSuggestionsClearRequested = () => {
    this.setState({ suggestions: [] });
  };

  getSuggestionValue = suggestion => suggestion.value;

  renderSuggestion = suggestion => suggestion.value;

  onSuggestionSelected = (ev, { suggestionValue }) => {
    const { data } = this.state;
    data.set('housing-area', slugify(suggestionValue));
    this.setState({ inputValue: suggestionValue, data });
  };

  changeValue = (event, { newValue }) => {
    const { data } = this.state;
    data.set('housing-area', slugify(newValue));
    this.setState({ inputValue: newValue, data });
  };

  filterSearch = value => {
    const slug = slugify(value);
    return this.props.cities
      .filter(item => item.slug.indexOf(slug) !== -1)
      .slice(0, 10)
      .map(item => ({ value: item.label }));
  };

  render() {
    const { handleChange, handleSubmit } = this;
    const { user, userLoading, subscriber, subscriptions } = this.props;
    const { data, update, suggestions, loading } = this.state;
    if (!user || userLoading || !this.state.loaded) {
      return null;
    }

    const inputValue =
      this.state.inputValue ||
      (data.get('housing-area') &&
        data.get('housing-area').length > 1 &&
        data.get('housing-area')) ||
      ''; // || data.get('housing-area') || '';
    const area =
      inputValue && this.props.cities.filter(s => s.slug === inputValue)[0];
    const inputProps = {
      value: area ? area.label : inputValue,
      onChange: this.changeValue,
      placeholder: this.i18n('Where do you want to live?')
    };

    return (
      <div className="tenant-signup">
        {subscriber ? (
          <div className="alert alert-info">
            {this.i18n(
              'Your %s is active.',
              this.i18n('Tenant Ad'),
              formatDate(subscriptions[0].endingAt)
            )}
            &nbsp;
            <Link to="/profile/subscription">
              {this.i18n('Click here for more details')}
            </Link>
            .
          </div>
        ) : null}

        <h1>{this.i18n('My tenant ad')}</h1>
        <form className="content-form form-tenant-create" name="form">
          <div className="form-section">
            <div className="form-section-label">
              <h3>{this.i18n('Contact details')}</h3>
            </div>

            <Row className="form-group">
              <Input
                type="text"
                name="profile-name"
                label={this.i18n('Name')}
                placeholder={this.i18n('Name')}
                defaultValue={user.name ? user.name : ''}
                onChange={handleChange}
              />
            </Row>
            <Row className="form-group">
              <Input
                type="text"
                name="profile-email"
                label={this.i18n('Email address')}
                placeholder={this.i18n('Email address')}
                defaultValue={user.email ? user.email : ''}
                onChange={handleChange}
              />
            </Row>
            <Row className="form-group">
              <Input
                type="text"
                name="profile-phone"
                label={this.i18n('Phone')}
                placeholder={this.i18n('Phone')}
                defaultValue={data.get('profile-phone') || null}
                onChange={handleChange}
              />
            </Row>
            <Row className="form-group">
              <Input
                type="text"
                name="profile-phonealt"
                label="&nbsp;"
                placeholder={this.i18n('Indtast evt. et ekstra telefonnummer')}
                defaultValue={data.get('profile-phonealt') || null}
                onChange={handleChange}
              />
            </Row>
          </div>
          <div className="form-section">
            <div className="form-section-label">
              <h3>{this.i18n('Your details')}</h3>
            </div>
            <Row className="form-group">
              <Input
                type="select"
                name="profile-gender"
                label={this.i18n('Gender')}
                placeholder={this.i18n('Gender')}
                defaultValue={data.get('profile-gender') || null}
                onChange={handleChange}
              >
                <option value="">{this.i18n('Choose gender')}</option>
                <option value="male">{this.i18n('Male')}</option>
                <option value="female">{this.i18n('Female')}</option>
              </Input>
            </Row>
            <Row className="form-group">
              <Input
                type="text"
                name="profile-age"
                label={this.i18n('Age')}
                placeholder={this.i18n('Age')}
                addonAfter={this.i18n('years')}
                defaultValue={data.get('profile-age') || null}
                onChange={handleChange}
              />
            </Row>
            <Row className="form-group">
              <Input
                type="text"
                name="profile-profession"
                label={this.i18n('Arbejdssituation')}
                placeholder={this.i18n('Arbejdssituation')}
                defaultValue={data.get('profile-profession') || null}
                onChange={handleChange}
              />
            </Row>
            <Row className="form-group">
              <Input
                type="select"
                name="profile-rki"
                label={this.i18n('Registreret i RKI?')}
                placeholder="select"
                defaultValue={
                  data.get('profile-rki') === false
                    ? data.get('profile-rki')
                    : data.get('profile-rki') === true
                    ? true
                    : null
                }
                onChange={handleChange}
              >
                <option value="">{this.i18n('Make a choice')}</option>
                <option value="false">{this.i18n('No')}</option>
                <option value="true">{this.i18n('Yes')}</option>
              </Input>
            </Row>
          </div>
          <div className="form-section">
            <div className="form-section-label">
              <h3>{this.i18n('Housing needs')}</h3>
            </div>
            <Row className="form-group">
              <Col sm={3} style={{ fontWeight: 'bold', color: '#444' }}>
                {this.i18n('Geografisk område')}
              </Col>
              <Col sm={9}>
                <Autosuggest
                  onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                  onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                  suggestions={suggestions}
                  inputProps={inputProps}
                  getSuggestionValue={this.getSuggestionValue}
                  renderSuggestion={this.renderSuggestion}
                  onSuggestionSelected={this.onSuggestionSelected}
                />
              </Col>
            </Row>
            <Row className="form-group">
              <label htmlFor="housing-rent" className="col-sm-3 control-label">
                {this.i18n('Rent')}
              </label>
              <div className="col-sm-9">
                <RangeSlider
                  anchorLeft
                  min={RENT_MIN}
                  max={RENT_MAX}
                  label={this.i18n('Maximum rent per month')}
                  step={RENT_STEP}
                  value={data.get('housing-rent')}
                  onSlide={this.getValue}
                  measurement={this.i18n('DKK')}
                  direction="ltr"
                  parentState="housing-rent"
                />
              </div>
              <label htmlFor="housing-rooms" className="col-sm-3 control-label">
                {this.i18n('Rooms')}
              </label>
              <div className="col-sm-9">
                <RangeSlider
                  min={ROOMS_MIN}
                  max={ROOMS_MAX}
                  label={this.i18n('Minimum number of rooms')}
                  step={ROOMS_STEP}
                  value={data.get('housing-rooms')}
                  onSlide={this.getValue}
                  measurement={this.i18n('Rooms')}
                  direction="ltr"
                  parentState="housing-rooms"
                />
              </div>
              <label htmlFor="housing-size" className="col-sm-3 control-label">
                {this.i18n('Size')}
              </label>
              <div className="col-sm-9">
                <RangeSlider
                  min={SIZE_MIN}
                  max={SIZE_MAX}
                  label={this.i18n('Minimum size')}
                  step={SIZE_STEP}
                  value={data.get('housing-size')}
                  onSlide={this.getValue}
                  measurement="m2"
                  direction="ltr"
                  parentState="housing-size"
                />
              </div>
            </Row>
            <div className="form-group row">
              <label htmlFor="housing-type" className="col-sm-3 control-label">
                {this.i18n('Housing type')}
              </label>
              <div className="col-sm-9">
                <CheckBox
                  handleChange={this.handleChange}
                  type="housing-dwelling-room"
                  value={data.get('housing-dwelling-room')}
                  label={this.i18n('Rooms')}
                />
                <CheckBox
                  handleChange={this.handleChange}
                  type="housing-dwelling-apartment"
                  value={data.get('housing-dwelling-apartment')}
                  label={this.i18n('Apartment')}
                />
                <CheckBox
                  handleChange={this.handleChange}
                  type="housing-dwelling-townhouse"
                  value={data.get('housing-dwelling-townhouse')}
                  label={this.i18n('Townhouse')}
                />
                <CheckBox
                  handleChange={this.handleChange}
                  type="housing-dwelling-villa"
                  value={data.get('housing-dwelling-villa')}
                  label={this.i18n('House/Villa')}
                />
              </div>
            </div>
            <div className="form-group row">
              <label htmlFor="housing-" className="col-sm-3 control-label">
                {this.i18n('Rental period')}
              </label>
              <div className="col-sm-9">
                <CheckBox
                  handleChange={this.handleChange}
                  type="housing-timeframe-nolimit"
                  value={data.get('housing-timeframe-nolimit')}
                  label={this.i18n('Unlimited')}
                />
                <CheckBox
                  handleChange={this.handleChange}
                  type="housing-timeframe-lt1y"
                  value={data.get('housing-timeframe-lt1y')}
                  label={this.i18n('Less than a year')}
                />
                <CheckBox
                  handleChange={this.handleChange}
                  type="housing-timeframe-gt1y"
                  value={data.get('housing-timeframe-gt1y')}
                  label={this.i18n('More than a year')}
                />
              </div>
            </div>
            <Row className="form-group">
              <label htmlFor="housing-" className="col-sm-3 control-label">
                {this.i18n('Seneste overtagelse')}
              </label>
              <div className="col-sm-9">
                <div className="input-group date">
                  <Datepicker
                    onChange={this.handleChange}
                    date={data.get('housing-available')}
                  />
                </div>
              </div>
            </Row>
          </div>
          <div className="form-section">
            <div className="form-section-label">
              <h3>{this.i18n('Annonce')}</h3>
            </div>
            <Row className="form-group">
              <Input
                type="text"
                label={this.i18n('Subject')}
                name="ad-subject"
                placeholder={this.i18n(
                  'Lav en kort, præcis og fængende overskrift til din annonce'
                )}
                defaultValue={data.get('ad-subject') || null}
                onChange={handleChange}
              />
            </Row>
            <Row className="form-group">
              <Input
                type="textarea"
                label={this.i18n('Annoncetekst')}
                name="ad-text"
                placeholder={this.i18n(
                  'Skriv lidt om dig selv og beskriv hvad du søger. Det kan være en god idé, at skrive, hvis du har specielle behov.'
                )}
                defaultValue={data.get('ad-text') || null}
                onChange={handleChange}
              />
            </Row>
          </div>
          <div className="form-group row">
            <div className="col-sm-offset-3 col-sm-9">
              <button
                type="button"
                disabled={loading}
                onClick={handleSubmit}
                className="btn btn-primary"
              >
                {this.i18n('Save tenant ad')}
              </button>
            </div>
          </div>
        </form>
        {loading ? <LoadingSpinner /> : null}
        {update ? (
          <div
            className={`alert ${
              update === SUCCESS ? 'alert-info' : 'alert-danger'
            } alert-info alert-last-dwelling`}
            role="alert"
          >
            {update === SUCCESS
              ? this.i18n('Annoncen er blevet oprettet.')
              : this.i18n('Der opstod en fejl. Prøv venligst igen')}
          </div>
        ) : null}
      </div>
    );
  }
}

export default Tenant;
